import type { ModuleManifest } from "./types";

export const eventsManifest: ModuleManifest = {
  name: "events",
  label: "Event",
  labelPlural: "Events",

  coreBOSModule: "cbCalendar",
  wsidPrefix: "39x",

  type: "standard",

  routes: {
    list: "/events",
    show: "/events/show/:id",
    create: "/events/create",
    edit: "/events/edit/:id",
  },

  navigation: {
    icon: "CalendarOutlined",
    order: 9,
    group: "CRM",
  },

  routing: {
    keywords: [
      "event",
      "events",
      "calendar",
      "meeting",
      "meetings",
      "call",
      "calls",
      "appointment",
      "appointments",
      "schedule",
    ],
    searchFields: ["subject", "activitytype"],
    defaultSort: { field: "dtstart", order: "desc" },
  },

  context: {
    supported: true,
    entityKey: "events",
  },

  fields: [
    { name: "subject", label: "Subject", type: "string", required: true },
    {
      name: "activitytype",
      label: "Activity Type",
      type: "picklist",
      required: true,
      options: [
        { value: "Call", label: "Call" },
        { value: "Meeting", label: "Meeting" },
        { value: "Task", label: "Task" },
      ],
    },
    {
      name: "dtstart",
      label: "Start Date/Time",
      type: "datetime",
      required: true,
    },
    { name: "dtend", label: "End Date/Time", type: "datetime", required: true },
    { name: "location", label: "Location", type: "string" },
    {
      name: "eventstatus",
      label: "Status",
      type: "picklist",
      options: [
        { value: "Planned", label: "Planned" },
        { value: "Held", label: "Held" },
        { value: "Not Held", label: "Not Held" },
      ],
    },
    {
      name: "taskpriority",
      label: "Priority",
      type: "picklist",
      options: [
        { value: "High", label: "High" },
        { value: "Medium", label: "Medium" },
        { value: "Low", label: "Low" },
      ],
    },
    {
      name: "sendnotification",
      label: "Send Notification",
      type: "boolean",
      defaultValue: false,
    },
    { name: "rel_id", label: "Related To", type: "reference" },
    {
      name: "cto_id",
      label: "Contact",
      type: "reference",
      referenceModule: "Contacts",
    },
    { name: "description", label: "Description", type: "text" },
    {
      name: "assigned_user_id",
      label: "Assigned To",
      type: "reference",
      referenceModule: "Users",
      hidden: true,
      defaultValue: "19x1",
    },
  ],

  relationships: [
    {
      module: "Contacts",
      field: "cto_id",
      label: "Contact",
      icon: "UserOutlined",
      displayField: "lastname",
    },
    {
      module: "Accounts",
      field: "rel_id",
      label: "Account",
      icon: "BankOutlined",
      displayField: "accountname",
    },
  ],

  requiredFields: [
    "subject",
    "activitytype",
    "dtstart",
    "dtend",
    "assigned_user_id",
  ],

  // Mass edit - fields are dynamically loaded from filterFields
  massEdit: {
    enabled: true,
  },
  viewStrategy: "bespoke",
};
